// extracted by mini-css-extract-plugin
module.exports = {"navigateBtnCol":"pipelineConfigurations_navigateBtnCol__3YCCi","dividerLine":"pipelineConfigurations_dividerLine__3pbcj"};